<template>
    <nio-modal
        name="conversation"
        size="sm"
        :title="$t('chat.newConversation.header')"
        ref="modal"
        @closed="onClosed"
        @opened="onOpened"
    >
        <nio-input-group :label="$t('chat.newConversation.selectContact')">
            <contact-select
                :phone-required="true"
                :selected-contact.sync="selectedContact"
                ref="contact"
                v-model="contactId"
            />
        </nio-input-group>

        <template #footer>
            <nio-button class="flex-1" :disabled="saving" @click="close">
                {{ $t('global.general.cancel') }}
            </nio-button>
            <nio-button
                class="flex-1"
                color="blue"
                :disabled="!contactId"
                :loading="saving"
                @click="validateContactPhones"
            >
                {{ $t('global.general.create') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapState } from 'vuex';
    import PhoneValidation from '@/mixins/PhoneValidation.js';
    import ContactSelect from '@/components/ContactSelect.vue';

    export default {
        components: {
            ContactSelect,
        },

        mixins: [PhoneValidation],

        data() {
            return {
                saving: false,
                contactId: null,
                contacts: [],
                selectedContact: null,
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        methods: {
            async validateContactPhones() {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                try {
                    await this.triggerValidatePhones(this.selectedContact);

                    this.createConversation();
                } catch (error) {
                    this.$notify.show({
                        type: 'error',
                        message: this.$t('chat.newConversation.errors.invalidNumberMessage'),
                    });

                    this.saving = false;
                }
            },

            async createConversation() {
                try {
                    const response = await this.$axios.post('conversations', {
                        contact_id: this.contactId,
                    });

                    this.$bus.emit('conversation.created', response.data.data);
                    this.close();
                } catch (error) {
                    if (error.response) {
                        if (error.response.status == 400) {
                            this.$notify.show({
                                type: 'warning',
                                message: this.$t('chat.newConversation.errors.conversationAlreadyExist'),
                            });

                            this.$bus.emit('conversation.created', error.response.data.data);
                            this.close();
                            return;
                        }

                        if (error.response.status == 422 &&
                            error.response.data.message == 'Limit exceeded.'
                        ) {
                            this.$notify.show({
                                type: 'warning',
                                message: this.$t('chat.newConversation.errors.limitExceeded'),
                            });

                            return;
                        }

                        if (error.response.status == 422 &&
                            error.response.data.message == 'No valid phone number for this contact.'
                        ) {
                            this.$notify.show({
                                type: 'warning',
                                message: this.$t('chat.newConversation.errors.noValidPhoneAvailable'),
                            });

                            return;
                        }
                    }

                    this.$notify.show({
                        type: 'error',
                        message: this.$t('global.errors.unknown'),
                    });
                } finally {
                    this.saving = false;
                }
            },

            onOpened() {
                this.$refs.contact?.open();
            },

            onClosed() {
                this.$reset();
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
